import { useRef } from "react";

export function useLastTruthyValue<T>(value: T | undefined): T | undefined {
  const ref = useRef<T>();
  if (value) ref.current = value;
  return ref.current;
}
